import Component from '../abstracts/Component';

export default class BookingAptComponent extends Component {

  get SELECTORS() {
    return {
      form: '.js-kr-booking',
      input: '.js-kr-booking input.form-control',
      submit: '.js-kr-booking .submit'
    };
  }


  constructor() {
    super();
  }

  bindEvents() {
    
    let ctx = this;

    let form =$(this.SELECTORS.form);
    let input=$(this.SELECTORS.input).not('#date');
    this.$on('blur', ({event}) => {
      if (input.filter('.error').length > 0 || input.filter(function() { return $(this).val() === ""; }).length > 0 || $('#date').val() === "" ) {
        $(this.SELECTORS.submit).prop('disabled', true)
      } else {
        $(this.SELECTORS.submit).prop('disabled', false)
      }

    },  $('body'), this.SELECTORS.input);


  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.bindEvents()
  }
}
